// ABOUTME: Top-edge "grab to move" handle for builder elements (section/row/divided half). An accent border
// ABOUTME: strip fades in along the top on hover — same shape as the grey resize edges, distinct colour so the
// ABOUTME: two never get confused. The strip carries the dnd-kit activator listeners.
import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

export const RhDragBar = ({ activatorRef, attributes, listeners, radius = 4, left = 0, right = 0, zIndex = 2, accent }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [hover, setHover] = useState(false);
    // Accent — distinct per element type (passed in by the caller so section/row/divided-half each read
    // differently). Defaults to blue/primary; deliberately NOT the grey used by the resize edges.
    const accentColor = accent ?? (theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]);

    return (
        <>
            {/* Curved accent surface clipped to the top edge — shown while the strip is hovered. */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left,
                    right,
                    borderRadius: radius,
                    border: `6px solid ${accentColor}`,
                    clipPath: "inset(0 0 calc(100% - 8px) 0)",
                    pointerEvents: "none",
                    transition: "opacity 120ms ease",
                    opacity: hover ? 1 : 0,
                    zIndex,
                }}
            />
            {/* The actual grab strip along the top edge. */}
            <Box
                ref={activatorRef}
                {...attributes}
                {...listeners}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                sx={{
                    position: "absolute",
                    top: 0,
                    left,
                    right,
                    height: 16,
                    cursor: "grab",
                    zIndex: zIndex + 1,
                    "&:active": { cursor: "grabbing" },
                }}
            />
        </>
    );
};
